import Page from '../page';
import LayoutNavigation from '../navigation/layout-navigation';

import Header2023 from '../pages/layouts/header-2023.vue';
import Header from '../pages/layouts/header.vue';
import Footer from '../pages/layouts/footer.vue';
import Article from '../pages/layouts/article.vue';
import ArticleMobileNav from '../pages/layouts/article-mobile-nav.vue';
import LatestNews from '../pages/layouts/latest-news.vue';
import NewsListing from '../pages/layouts/news-listing.vue';
import Recipe from '../pages/layouts/recipe.vue';
import Search from '../pages/layouts/search.vue';
import HospitalListLayout from '../pages/layouts/hospital-list-layout.vue';
import HospitalMapLayout from '../pages/layouts/hospital-map-layout.vue';
import ImpactMapLayout from '../pages/layouts/impact-map-layout.vue';
import SearchResults from '../pages/layouts/search-results.vue';
import SearchResultsCoveo from '../pages/layouts/search-results-coveo.vue';
import SearchResultsCoveoError from '../pages/layouts/search-results-coveo-error.vue';
import RecipeBox from '../pages/layouts/recipe-box.vue';
import RecipePreferences from '../pages/layouts/recipe-preferences';
import RecipeCategories from '../pages/layouts/recipe-categories';
import SurvivorStory from '../pages/layouts/survivor-story.vue';
import NotFound from '../pages/layouts/404.vue';
import Error from '../pages/layouts/500.vue';
import StrokeGroupFinder from '../pages/layouts/stroke-group-finder.vue';
import StrokeGroupDetail from '../pages/layouts/stroke-group-detail.vue';
import HospitalMaps from '../pages/layouts/hospitalmaps.vue';
import ThingsToKnow from '../pages/components/things-to-know.vue';
import ScienceNewsCommentary from '../pages/layouts/science-news-commentary.vue';
import ScienceNewsArticleWildecard from '../pages/layouts/science-news-article-summary-wildcard.vue';
import PhdLinkedListViewAllPage from '../components/phd/linked-list-view-all-page.vue';
import PhdHeader from '../pages/layouts/phd-header.vue';
import PhdMemberDashboardAccountSummary from '../pages/layouts/phd-member-dashboard-account-summary.vue';
import PhdMembershipTablesExample from '../pages/layouts/phd-membership-tables-example.vue';
import PhdCommunityTabs from '../pages/layouts/phd-community-tabs.vue';
import TierSelector from '../pages/layouts/tier-selector.vue';
import TierSelectorAPI from '../pages/layouts/tier-selector-api.vue';
import InstitutionMembership from '../pages/layouts/institution-membership-api.vue';
import ProgrammingTable from '../pages/layouts/programming-table.vue';
import PhdMeetings from '../pages/layouts/phd-meetings-sci-sessions.vue';

const LayoutPages = [
    {
        path: '/pages',
        // You could also have named views at the top
        components: {
            default: Page,
            'sidebar-nav': LayoutNavigation
        },
        children: [
            {
                path: '',
                redirect: 'header'
            },
            {
                path: 'header-2023',
                component: Header2023
            },
            {
                path: 'header',
                component: Header
            },
            {
                path: 'footer',
                component: Footer
            },
            {
                path: 'article',
                component: Article
            },
            {
                path: 'article-mobile-nav',
                component: ArticleMobileNav
            },
            {
                path: 'latest-news',
                component: LatestNews
            },
            {
                path: 'news-listing',
                component: NewsListing
            },
            {
                path: 'recipe',
                component: Recipe
            },
            {
                path: 'search',
                component: Search
            },
            {
                path: 'hospital-list-layout',
                component: HospitalListLayout
            },
            {
                path: 'hospital-map-layout',
                component: HospitalMapLayout
            },
            {
                path: 'Impact-map-layout',
                component: ImpactMapLayout
            },
            {
                path: 'search-results',
                component: SearchResults
            },
            {
                path: 'search-results-coveo',
                component: SearchResultsCoveo
            },
            {
                path: 'search-results-coveo-error',
                component: SearchResultsCoveoError
            },
            {
                path: 'recipe-box',
                component: RecipeBox
            },
            {
                path: 'recipe-preferences',
                component: RecipePreferences
            },
            {
                path: 'recipe-categories',
                component: RecipeCategories
            },
            {
                path: 'survivor-story',
                component: SurvivorStory
            },
            {
                path: 'not-found',
                component: NotFound
            },
            {
                path: 'error',
                component: Error
            },
            {
                path: 'stroke-group-finder',
                component: StrokeGroupFinder
            },
            {
                path: 'stroke-group-detail',
                component: StrokeGroupDetail
            },
            {
                path: 'hospitalmaps',
                component: HospitalMaps
            },
            {
                path: 'phd-member-dashboard-account-summary',
                component: PhdMemberDashboardAccountSummary
            },
            {
                path: 'phd-membership-tables',
                component: PhdMembershipTablesExample
            },
            {
                path: 'things-to-know',
                component: ThingsToKnow
            },
            {
                path: 'science-news-commentary',
                component: ScienceNewsCommentary
            },
            {
                path: 'science-news-article-wildcard',
                component: ScienceNewsArticleWildecard
            },
            {
                path: 'phd-linked-list-view-all-page',
                component: PhdLinkedListViewAllPage
            },
            {
                path: 'phd-header',
                component: PhdHeader
            },
            {
                path: 'tier-selector',
                component: TierSelector
            },
            {
                path: 'tier-selector-api',
                component: TierSelectorAPI
            },
            {
                path: 'institution-membership-api',
                component: InstitutionMembership
            },
            {
                path: 'programming-table',
                component: ProgrammingTable
            },
            {
                path: 'phd-community-tabs',
                component: PhdCommunityTabs
            },
            {
                path: 'phd-meetings-sci-sessions',
                component: PhdMeetings
            }
        ]
    }
];

export default LayoutPages;



// WEBPACK FOOTER //
// ./demo/routes/layouts.js